import Ajv from "ajv";

import { lvtResponseSchema } from "../common";

// TODO: do the schema
const archiveImagesNavMetaProperties = {
    liveUnitId: { type: "integer" },
    clientId: { type: "integer" },
    name: { type: "string" },
    recordingStart: { type: ["string", "null"] },
    archiveImagesStart: { type: ["string", "null"] },
    timezone: { type: "string" },
    cameraIds: { type: "array", items: { type: "integer" } },
};

const archiveImagesNavMetaSchema = {
    type: "object",
    additionalProperties: false,
    required: Object.keys(archiveImagesNavMetaProperties),
    properties: archiveImagesNavMetaProperties,
};

export const archiveImagesNavMetaValidator = new Ajv().compile(archiveImagesNavMetaSchema);

const lvtResponseArchiveImagesNavMetaSchema = lvtResponseSchema(archiveImagesNavMetaSchema);

export const lvtResponseArchiveImagesNavMetaValidator = new Ajv().compile(lvtResponseArchiveImagesNavMetaSchema);
